import React from 'react';
import styled from 'styled-components';

export interface AppLayoutPropsType {
  children: React.ReactNode | React.ReactNode[];
}

/**
 * 페이지 레이아웃 컴포넌트 _app.tsx에서 사용
 * @author 이현우
 * @param param0
 * @returns
 */
const AppLayout = ({ children }: AppLayoutPropsType) => {
  return (
    <Layout>
      <Container>
        <Main>{children}</Main>
      </Container>
    </Layout>
  );
};

export default AppLayout;

const Layout = styled.div`
  width: 100%;
  margin: 0 auto;
  height: 100dvh;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Main = styled.main`
  flex: 1;
  width: 100%;
  background-color: inherit;
  height: fit-content;
`;
